import * as React from 'react';
import classNames from 'classnames';
import './badge.scss';
import { Wrapper } from './Wrapper';
import { BadgeIcon } from './BadgeIcon';
export const Badge = ({ badge, size, layout, background, borderRadius, font, textStyle, truncateTitle, hideDefaultIcon, onClick, onLoadIcon, httpClient, }) => {
    const backgroundClass = background ? '' : 'no-background';
    const cursorClass = onClick ? 'pointer' : '';
    const wrapperClass = classNames('wrapper', size, layout, backgroundClass, cursorClass);
    const showName = layout !== 'icon-only';
    const textClass = classNames('text', truncateTitle && 'truncated');
    const onBadgeClick = () => {
        if (onClick) {
            onClick(badge);
        }
    };
    return (React.createElement(Wrapper, { badge: badge, layout: layout },
        React.createElement("div", { onClick: onBadgeClick, className: wrapperClass, style: {
                backgroundColor: badge.backgroundColor,
                borderRadius: `${borderRadius}px`,
            } },
            React.createElement("div", { className: "inner" },
                React.createElement(BadgeIcon, { layout: layout, size: size, badgeIcon: badge.icon, hideDefaultIcon: hideDefaultIcon, onLoadIcon: onLoadIcon, httpClient: httpClient }),
                showName && (React.createElement("span", { className: textClass, style: Object.assign({ color: badge.textColor, fontFamily: font }, textStyle) }, badge.title))))));
};
//# sourceMappingURL=Badge.js.map